/*eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react"

function useForceUpdate() {
  const [valueFU, setValueFU] = useState(0) // integer state
  return () => setValueFU(valueFU => valueFU + 1) // update the state to force render
}

export default useForceUpdate
